import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import StudentAvatar from "@/components/StudentAvatar";
import { CalendarOff, Clock } from "lucide-react";
import { YEAR_LABEL } from "@/lib/school";

export function OnLeaveTodayCard() {
  const { data: rows = [], isLoading } = useQuery({
    queryKey: ["on-leave-today"],
    queryFn: async () => (await api.get("/school-stats/on-leave-today")).data,
    refetchInterval: 5 * 60_000,
  });
  return (
    <Card className="p-5 border border-stone-200 rounded-xl shadow-none mb-6" data-testid="on-leave-today-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2 text-sm font-medium text-[#1C352D]">
          <CalendarOff size={16} className="text-[#E2725B]" /> In permesso oggi
        </div>
        <span className="text-xs text-stone-500" data-testid="on-leave-today-count">{rows.length} {rows.length === 1 ? "studente" : "studenti"}</span>
      </div>
      {isLoading ? (
        <div className="text-xs text-stone-400">Caricamento…</div>
      ) : rows.length === 0 ? (
        <div className="text-sm text-stone-400" data-testid="on-leave-today-empty">Nessuno studente in permesso oggi.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          {rows.map((r) => (
            <Link key={r.request_id} to={`/richieste/${r.request_id}`} data-testid={`on-leave-${r.request_id}`}
              className="flex items-center gap-3 rounded-lg border border-stone-200 px-3 py-2 hover:border-[#1C352D] transition-colors duration-150">
              <StudentAvatar studentId={r.student_id} photoPath={r.photo_v} name={r.student_name} className="w-9 h-9 rounded-full text-xs" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{r.student_name}{r.year_level && <span className="text-[11px] text-stone-400 font-normal ml-1.5">{YEAR_LABEL[r.year_level]}</span>}</div>
                <div className="text-[11px] text-stone-500 truncate">{r.medical && <span className="text-sky-700 font-medium">Visita medica · </span>}{r.subject}</div>
              </div>
              <div className="text-right shrink-0">
                <div className="text-xs text-[#1C352D] inline-flex items-center gap-1">
                  <Clock size={11} /> {r.time_from && r.time_to ? `${r.time_from}–${r.time_to}` : r.half_day ? "Mezza giornata" : "Giornata intera"}
                </div>
                {r.in_progress && <div className="text-[10px] font-semibold text-[#E2725B] uppercase tracking-wider" data-testid={`on-leave-live-${r.request_id}`}>in corso</div>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </Card>
  );
}
